export const KEY_CONTACT_POSITION = 'Key Contact';

export const SUB_BUYER_ID = 12;
